module.exports = __webpack_public_path__ + "img/img-thumb.06473857.png";